enum EResponseStatusCode {
	ok = 200,
	unauthorized = 401,
	server_error = 500,
}

export default EResponseStatusCode;
